export default "__VITE_ASSET__b7e528dc__"